/**
 * Convierte la primera letra de un string a mayúscula
 */
export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * Trunca un string a una longitud máxima
 */
export const truncate = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + '...';
};

/**
 * Formatea un número como moneda
 */
export const formatCurrency = (
  amount: number,
  currency: string = 'EUR',
  locale: string = 'es-ES',
  noDecimals: boolean = false
): string => {
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currency,
  };

  if (noDecimals) {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = 0;
  } else {
    // Mostrar decimales por defecto (2 dígitos)
    options.minimumFractionDigits = 2;
    options.maximumFractionDigits = 2;
  }

  return new Intl.NumberFormat(locale, options).format(amount);
};

/**
 * Debounce function para optimizar búsquedas
 */
export const debounce = <T extends (...args: unknown[]) => unknown>(
  func: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

/**
 * Serialize an object to a query string
 */
export const serializeQuery = (params: Record<string, unknown>): string => {
  const queryString = Object.entries(params)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((v) => `${encodeURIComponent(key)}[]=${encodeURIComponent(String(v))}`).join('&');
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
    })
    .join('&');
  return queryString;
};

/**
 * Is valid JSON
 */
export const isValidJSON = (str: string): boolean => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};
